@let walkingFarmProperties = walkingFarmProperties$ | async;

<cdk-virtual-scroll-viewport
  itemSize="153"
  minBufferPx="1530"
  maxBufferPx="3060"
  class="ion-content-scroll-host tw:h-full tw:w-full"
>
  @if (walkingFarmProperties) {
    <ion-list [inset]="false" [lines]="walkingFarmProperties.length > 1 ? 'full' : 'none'">
      <ion-reorder-group [disabled]="reorderingDisabled" (ionItemReorder)="handleReorder($event)">
        <ng-container *cdkVirtualFor="let property of walkingFarmProperties; trackBy: propertiesListTrackBy">
          <ion-item-sliding>
            <ion-item
              [button]="true"
              [detail]="false"
              [routerLink]="[
                defaultBackHref,
                'walking-farm',
                walkingFarmId,
                'view',
                'property',
                property.A000_PropertyNumber
              ]"
            >
              <ion-label class="tw:leading-4">
                <div class="tw:leading-5">
                  <ion-text color="medium" class="tw:text-base tw:font-bold">{{
                    property | redAddress: addressType.LineOne
                  }}</ion-text>
                </div>
                <div>
                  <ion-text color="medium" class="tw:text-xs">{{
                    property | redAddress: addressType.LineTwo
                  }}</ion-text>
                </div>
                <div class="tw:flex tw:items-center tw:gap-2">
                  <div>
                    <ion-icon
                      size="large"
                      [src]="
                        property.A040_OwnerOccupied === 'N'
                          ? '/assets/svg/owner-unoccupied.svg'
                          : '/assets/svg/owner-occupied.svg'
                      "
                    ></ion-icon>
                  </div>
                  <div class="tw:flex tw:h-14 tw:flex-col tw:justify-center">
                    <div class="tw:max-h-9 tw:overflow-hidden">
                      <ion-text color="medium" class="tw:text-xs">
                        {{ property | redOwnerName: ownerNameType.Full }}
                      </ion-text>
                    </div>
                    <div class="tw:leading-5">
                      <ion-text color="medium" class="tw:text-sm">
                        {{ property.A022_BuildingArea | redSurface }} &#9679;
                        {{ property.A025_Bathrooms | redDashIfEmpty }} BA &#9679;
                        {{ property.A024_Bedrooms | redDashIfEmpty }} BR
                      </ion-text>
                    </div>
                  </div>
                </div>
                <div class="tw:flex tw:items-center">
                  <red-walking-farm-property-lead-status-selector
                    class="tw:block tw:w-40"
                    [property]="property"
                    [walkingFarmId]="walkingFarmId"
                  >
                  </red-walking-farm-property-lead-status-selector>
                  @if (property.contactDetails?.length) {
                    <ion-icon name="call" color="success" class="tw:ml-2"></ion-icon>
                  }
                </div>
              </ion-label>
              @if (organizationFarmAlertsEnabled$ | async) {
                @let walkingFarmFarmAlertsEnabled = walkingFarmFarmAlertsEnabled$ | async;

                <ion-button
                  [routerLink]="[
                    defaultBackHref,
                    'walking-farm',
                    walkingFarmId,
                    'view',
                    'property',
                    property.A000_PropertyNumber,
                    'alerts'
                  ]"
                  (click)="$event.stopPropagation()"
                  [color]="property.unreadFarmAlerts ? 'danger' : walkingFarmFarmAlertsEnabled ? 'success' : 'medium'"
                  slot="end"
                  class="tw:relative"
                  shape="round"
                >
                  @if (property.unreadFarmAlerts) {
                    {{ property.unreadFarmAlerts }}
                  }
                  <ion-icon
                    [name]="walkingFarmFarmAlertsEnabled ? 'notifications-outline' : 'notifications-off-outline'"
                  ></ion-icon>
                </ion-button>
              }
              <ion-reorder slot="end"> </ion-reorder>
            </ion-item>
          </ion-item-sliding>
        </ng-container>
      </ion-reorder-group>
    </ion-list>
  }
</cdk-virtual-scroll-viewport>
